import httpbaseURL from "../common/axios";
class Commonservices {
  ChangePassword(ObjaVAl) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/Password/ChangePassword",
      ObjaVAl
    );
  }
  GetUserMailId(EmailId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/Password/GetUserMailId?EmailId=" + EmailId + ""
    );
  }

  GetUserMailIdPassword(EmailId, Password) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/Password/GetUserMailIdPassword?EmailId=" + EmailId + "&Password=" + Password + ""
    );
  }

  GetUserById(UserId) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.get(
      "/Password/GetUserById?id=" + UserId + ""
    );
  }

  ForgotPasswordSendMail(UserObj) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.post(
      "/Password/ForgotPasswordSendMail",
      UserObj
    );
  }
}
export default new Commonservices();
